import meStore from "./meStore";
import appStore from "./appStore";
import userStore from "./userStore";
import companyStore from "./companyStore";
import courierStore from "./courierStore";
import orderStore from "./orderStore";
import apiRequestStore from "./apiRequestStore";
import regionStore from "./regionStore";
import appConfigStore from "./appConfigStore";
import statisticStore from "./statisticStore";
import heatMapStore from "./heatMapStore";
import walletStore from "./walletStore";
import shiftStore from "./shiftStore";
import transferStore from "./transferStore";
import shiftSuggestionStore from "./shiftSuggestionStore";
import paymentPeriodStore from "./paymentPeriodStore";
import authorizationStore from "./authorizationStore";
import poolStore from "./poolStore";
import locationStore from "./locationStore";
import shiftRequestStore from "./shiftRequestStore";
import poolShiftStore from "./poolShiftStore";
import courierBonusCampaignStore from "./courierBonusCampaignStore";
import optionsStore from "./optionsStore";
import codPaymentStore from "./codPaymentStore";
import contractStore from "./contractStore";
import supplierStore from "./supplierStore";
import integratorStore from "./integratorStore";
import subCompanyStore from "./subCompanyStore";

export default {
    meStore,
    appStore,
    authorizationStore,
    userStore,
    companyStore,
    courierStore,
    orderStore,
    apiRequestStore,
    regionStore,
    appConfigStore,
    statisticStore,
    walletStore,
    heatMapStore,
    shiftStore,
    transferStore,
    shiftSuggestionStore,
    paymentPeriodStore,
    poolStore,
    poolShiftStore,
    courierBonusCampaignStore,
    locationStore,
    shiftRequestStore,
    optionsStore,
    codPaymentStore,
    contractStore,
    supplierStore,
    integratorStore,
    subCompanyStore
};
